module.exports = ":host {\n  flex: 1 1 auto; }\n"